import { useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"

/**
 * useCompleteTransferApplicationフックの戻り値の型定義
 */
interface UseCompleteTransferApplicationReturn {
  /** 立替送金申請を完了する関数 */
  completeTransferApplication: (id: number) => Promise<void>
  /** 完了処理中かどうか */
  isCompleting: boolean
}

/**
 * 立替送金申請を完了するためのカスタムフック
 *
 * @returns 完了機能とその状態
 *
 */
export const useCompleteTransferApplication = (): UseCompleteTransferApplicationReturn => {
  const { patchWithToken } = useSmoothApi()
  const [isCompleting, setIsCompleting] = useState(false)

  /**
   * 立替送金申請を完了する
   * @param id - 申請ID
   */
  const completeTransferApplication = async (id: number): Promise<void> => {
    setIsCompleting(true)

    try {
      const url = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/transfer_applications/${id}/complete`
      await patchWithToken(url)
    } finally {
      setIsCompleting(false)
    }
  }

  return {
    completeTransferApplication,
    isCompleting,
  }
}
